import { getRequest, postRequest } from "../utils/api";

export const loginRequest = async (values) => {
  const response = await postRequest("/Account/CheckCredential", values);

  return response;
};
//Added for wosh
export const userRole = async (email) => {
  console.log(`Fetching role for email: ${email}`);
  const response = await getRequest(`/Account/GetRole/?email=${email}`);
  return response;

};



